import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { NoRecordsWrapper } from '@layouts/Layouts/TableLayout';

import type { RoutineRecord } from '@models/routine';

import { ListHeader, RoutineListDiv } from './RoutineList.style';
import RoutineListItem from './RoutineListItem';

const messages = defineMessages({
  allRoutines: {
    id: 'routineList.allRoutines',
    defaultMessage: 'All Routines',
  },
  noRoutines: {
    id: 'routineList.noRoutines',
    defaultMessage: 'No Routines',
  },
});

function RoutineList({
  width = '100%',
  routines = [],
  showHeader = true,
}: {
  width?: string;
  routines: RoutineRecord[];
  showHeader?: boolean;
}) {
  const { formatMessage } = useIntl();

  return routines.length === 0 ? (
    <NoRecordsWrapper>{formatMessage(messages.noRoutines)}</NoRecordsWrapper>
  ) : (
    <RoutineListDiv width={width}>
      {showHeader ? (
        <ListHeader>{formatMessage(messages.allRoutines)}</ListHeader>
      ) : null}
      {routines.map((r) => {
        return (
          <RoutineListItem
            description={r.instructions}
            id={r.id}
            key={r.id}
            name={r.name}
          />
        );
      })}
    </RoutineListDiv>
  );
}

export default RoutineList;
